import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchHistoryMessages,
  messagesSelector,
} from "../../../service/redux/messages/messagesSlice";
import { Auth } from "../../../service/utils/auth";
import "./ConversationList.css";

const ConversationList = () => {
  const navigate = useNavigate();
  const { userId: activeUserId } = useParams();
  const { userID } = new Auth();
  const dispatch = useDispatch();
  const { historyMessages } = useSelector(messagesSelector) || {};
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    if (userID) {
      dispatch(fetchHistoryMessages(userID));
    }
  }, [userID, dispatch]);

  // Tự động chọn conversation đầu tiên khi load
  useEffect(() => {
    if (!activeUserId && historyMessages && historyMessages.length > 0) {
      const firstUserId = historyMessages[0].OtherUserID;
      if (firstUserId) {
        navigate(`/message/${firstUserId}`, { replace: true });
      }
    }
  }, [historyMessages, activeUserId, navigate]);

  const filteredConversations = historyMessages?.filter((conv) =>
    conv.OtherUsername?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleSelectConversation = (userId) => {
    navigate(`/message/${userId}`);
  };

  return (
    <div className="conversation-list">
      {/* Header */}
      <div className="conversation-header">
        <h2 className="conversation-title">Chat</h2>
        <button className="new-chat-btn" title="Tạo cuộc trò chuyện mới">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="10"
              cy="10"
              r="8"
              stroke="currentColor"
              strokeWidth="2"
            />
            <path
              d="M10 6V14M6 10H14"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        </button>
      </div>

      {/* Search Bar */}
      <div className="conversation-search">
        <svg
          className="search-icon"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="8" cy="8" r="6" stroke="currentColor" strokeWidth="2" />
          <path
            d="M12 12L16 16"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
        <input
          type="text"
          className="search-input"
          placeholder="Tìm kiếm cuộc trò chuyện"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      {/* Conversation List */}
      <div className="conversations-container">
        {filteredConversations && filteredConversations.length > 0 ? (
          filteredConversations.map((conversation) => (
            <div
              key={conversation.OtherUserID}
              className={`conversation-item ${
                String(activeUserId) === String(conversation.OtherUserID)
                  ? "active"
                  : ""
              }`}
              onClick={() => handleSelectConversation(conversation.OtherUserID)}
            >
              <div className="conversation-avatar">
                {conversation.OtherAvatar ? (
                  <img
                    src={conversation.OtherAvatar}
                    alt={conversation.OtherUsername}
                  />
                ) : (
                  <div className="avatar-placeholder">
                    {conversation.OtherUsername?.charAt(0).toUpperCase() || "U"}
                  </div>
                )}
                {conversation.UnreadCount > 0 && (
                  <div className="unread-badge">{conversation.UnreadCount}</div>
                )}
              </div>
              <div className="conversation-info">
                <div className="conversation-name-row">
                  <h4 className="conversation-name">
                    {conversation.OtherUsername}
                  </h4>
                  <span className="conversation-time">
                    {conversation.MessageTime
                      ? new Date(conversation.MessageTime).toLocaleTimeString(
                          "vi-VN",
                          {
                            hour: "2-digit",
                            minute: "2-digit",
                          }
                        )
                      : ""}
                  </span>
                </div>
                <div className="conversation-last-message">
                  {conversation.Content || "Chưa có tin nhắn"}
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="no-conversations">
            <div className="no-conversations-icon">💬</div>
            <p>Chưa có cuộc trò chuyện nào</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ConversationList;
